import { useLocalContext } from "@/setup/locale-provider";
import { Breadcrumbs, Skeleton, Text } from "@mantine/core";
import Link from "next/link";
import PropTypes from "prop-types";

function AppBreadcrumbs({ items, isLoading }) {
  const { getLabel } = useLocalContext();
  return (
    <Skeleton visible={isLoading}>
      <Breadcrumbs>
        {items?.map((item, index) => (
          <Link key={index} href={item.href || "#"} scroll={false}>
            <a>
              {/* <Anchor href={item.href}> */}
              <Text
                color="dark"
                size="sm"
                lineClamp={index === items.length - 1 ? 1 : 2}
                sx={{
                  width:
                    index === items.length - 1 ? "fit-content" : "max-content",
                }}
              >
                {getLabel(item.title)}
              </Text>
              {/* </Anchor> */}
            </a>
          </Link>
        ))}
      </Breadcrumbs>
    </Skeleton>
  );
}

AppBreadcrumbs.propTypes = {
  items: PropTypes.array.isRequired,
};

export default AppBreadcrumbs;
